module.exports = __webpack_public_path__ + "img/z15.925a74c2.jpg";